import { Box, Button, Text } from "@chakra-ui/react";
import { addYears, format } from "date-fns";
import { enUS } from "date-fns/locale";
import { useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const CustomerDateRangePicker = ({ onChange }) => {
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const handleApply = () => {
    // Pass dates to parent component
    onChange({
      fromDate: range[0].startDate,
      toDate: range[0].endDate,
    });
  };

  return (
    <Box p={4} bg="white" borderRadius="md" shadow="sm">
      <Text mb={2} fontWeight="bold">Select Custom Date Range</Text>
      <DateRange
        ranges={range}
        onChange={handleSelect}
        moveRangeOnFirstSelection={false}
        maxDate={addYears(new Date(), 1)}
        locale={enUS}
      />
      <Box mt={2}>
        <Text fontSize="sm" color="gray.600">
          From: {format(range[0].startDate, "dd MMM yyyy")}
        </Text>
        <Text fontSize="sm" color="gray.600">
          To: {format(range[0].endDate, "dd MMM yyyy")}
        </Text>
      </Box>
      <Button mt={3} colorScheme="orange" size="sm" onClick={handleApply}>
        Apply Filter
      </Button>
    </Box>
  );
};

export default CustomerDateRangePicker;
